<mat-card style="padding: 0;" [routerLink]="['/join', game.gameId]" routerLinkActive="active">
  <!-- adding mat ripple to mat card has a bug, mat card resizes on click, workaround -->
  <mat-card-content matRipple style="margin: 0; padding: 16px; border-radius: 4px;">
    <!-- <div>{{ game | json }}</div> -->
    <div><b>Game ID:</b> {{ game.gameId }}</div>
    <div>
      <b>Created Time:</b>
      {{ (game ? game.createdTimestamp.toDate() : '') | date: 'yyyy-mm-dd hh:mm a' }}
    </div>
  </mat-card-content>
</mat-card>
